import { render, staticRenderFns } from "./GuidePriceEditor.vue?vue&type=template&id=39c50e32&scoped=true"
import script from "./GuidePriceEditor.vue?vue&type=script&lang=js"
export * from "./GuidePriceEditor.vue?vue&type=script&lang=js"
import style0 from "./GuidePriceEditor.vue?vue&type=style&index=0&id=39c50e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c50e32",
  null
  
)

export default component.exports